import { LoadableAfterPaint } from '@confluence/loadable';

export const HelpPanel = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-HelpPanel" */ '../src/HelpPanel.tsx')).HelpPanel,
});
